import React from 'react';
import TabsSection from '../../components/TabSection';

const Solutions2 = () => {
  const cardData = [
    {
      title: "ERP",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359416/image-20_yayddy.png",
    },
    {
      title: "OPPORTUNITIES",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359416/image-21_pkyis8.png",
    },
    {
      title: "RESOURCES",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359416/image-22_jiwvna.png",
    },
  ];

  return (
    <div className="bg-white">
      <div className="md:px-28 px-4 md:pt-3 pt-2 md:pb-14 pb-4">

        <h1 className="text-[14px] md:text-[36px] font-bold md:mt-6  md:mb-6  mt-2 text-[#152C24]">INVESTOR</h1>
        
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745578265/image_33_f2pos8.png"
          alt="Securing Agriculture in Namibia"
          className="w-full md:h-[480px] object-cover md:rounded-lg rounded-md transition-opacity duration-500"
        />

        <section className="flex-1 mt-10">
          <h2 className="text-[32px] font-bold text-[#152C24] mb-6">
            <strong className="font-bold text-black">INVESTORS: </strong> How can they benefit?
          </h2>
          <h2 className="font-bold text-[32px] text-black mb-6">
          A Finvestor—which could be a financial investor, agri-fintech company, microfinance institution, or impact investor—gets significant advantages by using the Farmnet App to support and scale investments in agriculture
            </h2>
          <div className="space-y-10 text-[18px] md:text-[32px]">
            {[
              { title: "Access to Verified, Creditworthy Farmers", content: [
                "Farmnet provides detailed farmer profiles, farm sizes, crops, production history, and income potential.",
                "Helps assess risk and creditworthiness with real data—great for lending decisions."
              ] },
              { title: "Loan Deployment at Scale", content: [
                "Easily disburse and track loans digitally to thousands of farmers through mobile money or digital wallets.",
                "Reduces overhead and improves efficiency in rural financing."
              ] },
              { title: "Transparent Use of Funds", content: [
                "Monitor how financing is being used—e.g., for seeds, fertilizer, or equipment—through farm activity logs and input records.",
                "Reduces misuse and improves repayment reliability."
              ] },
              { title: "Real-Time Monitoring & Reporting", content: [
                "Track repayment rates, crop growth, market prices, and external risks (like droughts or pests).",
                "Helps in portfolio management, forecasting, and compliance reporting."
              ] },
              { title: "Built-in Risk Management Tools", content: [
                "Leverage weather forecasts, crop data, and digital traceability to mitigate climate or production risks.",
                "Supports bundling of financial products like weather-indexed insurance."
              ] },
              { title: "Improve Farmer Financial Literacy", content: [
                "Farmnet supports financial education content delivery, helping farmers understand credit, savings, and repayments.",
                "Leads to better repayment behavior and trust in financial systems."
              ] },
              { title: "Integration with Development Projects", content: [
                "Co-finance or align with donor-funded programs, government subsidies, or insurance schemes.",
                "De-risks investment while delivering social and economic impact."
              ] },
              { title: "Impact Tracking & ESG Reporting", content: [
                "Easily collect impact data: income changes, productivity, gender inclusion, resilience, etc.",
                "Strengthens ESG (Environmental, Social, Governance) credentials and impact reporting."
              ] },
              { title: "Faster Scaling Across Regions", content: [
                "Plug into Farmnet’s existing network of farmers, cooperatives, and service providers in multiple regions.",
                "Expand your agri-finance operations faster and smarter."
              ] },
              { title: "Competitive Advantage", content: [
                "Stay ahead with real-time insights, digital lending, and embedded services.",
                "Compete more effectively in the fast-growing digital agriculture and rural finance space."
              ] }
            ].map((section, index) => (
              <div key={index}>
                <strong>{index + 1}. {section.title}</strong>
                <ul className="list-disc md:pl-12 mt-2 text-black">
                  {section.content.map((text, idx) => (
                    <li key={idx}>{text}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Solutions2;
